import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DiscussionViewerComponent } from "./discussion-viewer.component";
import { ViewableDiscussionResolver } from "../../../shared/services";

const routes: Routes = [
  {
    path: "", // path is "discussion/:discussion"
    component: DiscussionViewerComponent,
    resolve: {
      discussion: ViewableDiscussionResolver,
    },
    data: {
      title: "Discussion Viewer",
      icon: "ti-layout-sidebar-left",
      caption: "Read something nice today :)",
      status: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DiscussionViewerRoutingModule {}
